import React from "react";
import BarekamText from "../../../../../../components/text";
import { Message, MessageSections } from "../../../../../../components/message/message";
import { BarekamSelect } from "../../../../../../components/select/select";
import { MenuItem } from "@mui/material";
import { UserStatusModel } from "../../../../../../shared/models/user/user-status";
import { OrderStateModel } from "../../../../../../shared/models/order/order-status";
import { ManagementPageType } from "../../../../../../../management-pages/user-order-management/management-data-container";

const CustomerStatusFilter = ({ selectedStatusId, userStatuses, onFilterChange, filterType, orderStatuses, onOrderFilterChange }: CustomerStatusFilterProps) => {
    return (
        <>
            <BarekamSelect
                variant={'outlined'}
                label={<Message messageKey={'user_status'} sectionId={MessageSections.ORDERS} />}
                value={selectedStatusId || 'all'}
                type={"filter"}
                sx={{ width: '20%' }}
                required>
                <MenuItem onClick={() => onFilterChange?.(undefined) || onOrderFilterChange?.(undefined)}
                    value={'all'}
                    key={'all'}>
                    <BarekamText variant={"m"}>
                        <Message messageKey={"all"} sectionId={MessageSections.ORDERS} />
                    </BarekamText>
                </MenuItem>
                {filterType === ManagementPageType.MOBILE_ORDERS ?
                    orderStatuses?.map(status =>
                        <MenuItem onClick={() => onOrderFilterChange?.(status)}
                            value={status.state}
                            key={status.state}>
                            <BarekamText variant={"m"}>
                                <Message messageKey={status.state} sectionId={MessageSections.ORDERS} />
                            </BarekamText>
                        </MenuItem>
                    )
                : 
                    userStatuses?.map(status =>
                        <MenuItem onClick={() => onFilterChange?.(status)}
                            value={status.userStatusId}
                            key={status.userStatusId}>
                            <BarekamText variant={"m"}>
                                <Message messageKey={status.name} sectionId={MessageSections.ORDERS} />
                            </BarekamText>
                        </MenuItem>
                    )
                }
            </BarekamSelect>
        </>
    );
};

export default CustomerStatusFilter;

interface CustomerStatusFilterProps {
    selectedStatusId: number | undefined | string;
    userStatuses?: UserStatusModel[];
    orderStatuses?: OrderStateModel[];
    onFilterChange?: (filter: UserStatusModel | undefined) => void;
    onOrderFilterChange?: (filter: OrderStateModel | undefined) => void;
    filterType?: ManagementPageType.CUSTOMERS | ManagementPageType.MOBILE_USER | ManagementPageType.MOBILE_ORDERS
}